import { baseEventDefinitions } from "./base";
import { interventionEventDefinitions } from "./intervention";
import { personalisedCoverEventDefinitions } from "./personalised_cover";
import { qcpEventDefinitions } from "./qcp";
import { questionnaireEventDefinitions } from "./questionnaire/questionnaire";
import { coverageSelectionEventDefinitions } from "./coverage-selection";
import { referralEventDefinitions } from "./referral";

// All events (keep up to date with new files)
export const eventDefinitions = [
  ...baseEventDefinitions,
  ...qcpEventDefinitions,
  ...referralEventDefinitions,
  ...interventionEventDefinitions,
  ...questionnaireEventDefinitions,
  ...personalisedCoverEventDefinitions,
  ...coverageSelectionEventDefinitions,
];

export const qcpPageEvents = [...baseEventDefinitions, ...qcpEventDefinitions];

export const referralPageEvents = [
  ...baseEventDefinitions,
  ...referralEventDefinitions,
];

export const interventionPageEvents = [...interventionEventDefinitions];

export type { InterventionPayload } from "./intervention";

export const questionnairePageEvents = [...questionnaireEventDefinitions];

export const coverageSelectionPageEvents = [
  ...baseEventDefinitions,
  ...coverageSelectionEventDefinitions,
];

// Create a new export for each kind of page below
// containing just the subset needed for that page
